/* Quote Builder (sections/csl-quote-builder.liquid)
   - categories from the menu JSON island → sub-categories → product rows
     loaded via the Section Rendering API (sections/csl-qb-data.liquid)
   - predictive search for any product
   - quote list in localStorage, CSV / print, contact-form submission          */
(function () {
  'use strict';
  var STORAGE_KEY = 'csl-quote-v1';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readList() { try { var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeList(list) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ } }

  function init(root) {
    if (!root || root.dataset.qbReady) return;
    root.dataset.qbReady = '1';
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var pageSize = parseInt(root.dataset.pageSize, 10) || 250;
    var cats = [];
    try { cats = JSON.parse(root.querySelector('[data-qb-categories]').textContent) || []; } catch (e) { cats = []; }

    var $ = function (sel) { return root.querySelector(sel); };
    var topChips = $('[data-top-chips]'), subChips = $('[data-sub-chips]');
    var listWrap = $('[data-list]'), listTitle = $('[data-list-title]'), listCount = $('[data-list-count]');
    var rows = $('[data-rows]'), loadMore = $('[data-load-more]'), listMsg = $('[data-list-msg]');
    var listFilter = $('[data-list-filter]'), listBrand = $('[data-list-brand]');
    var search = $('[data-search]'), results = $('[data-results]'), spinner = $('[data-search-spinner]');
    var rowTpl = $('[data-tpl-row]'), cartRowTpl = $('[data-tpl-cart-row]');
    var cartRows = $('[data-cart-rows]'), cartEmpty = $('[data-cart-empty]'), cartTotals = $('[data-cart-totals]'), cartTotal = $('[data-cart-total]'), cartCount = $('[data-cart-count]');
    var btnRequest = $('[data-open-request]'), btnDownload = $('[data-download]'), btnPrint = $('[data-print]'), btnClear = $('[data-clear]');
    var dialog = $('[data-request-dialog]');
    var postedBanner = $('[data-posted-banner]');

    var state = { list: readList(), cat: null, sub: null, handle: null, page: 1, pages: 1, products: [], loading: false };

    function money(cents) {
      var n = (parseInt(cents, 10) || 0) / 100;
      var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
    }
    function flash(msg) {
      var el = document.createElement('div');
      el.className = 'qb-flash';
      el.textContent = msg;
      document.body.appendChild(el);
      setTimeout(function () { el.remove(); }, 1600);
    }

    /* ---------- categories ---------- */
    function chip(label, count, attrs) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qb-chip';
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = esc(label) + (count ? ' <span class="qb-chip__n">' + esc(count.toLocaleString()) + '</span>' : '');
      Object.keys(attrs || {}).forEach(function (k) { b.dataset[k] = attrs[k]; });
      return b;
    }
    cats.forEach(function (c, i) {
      if (!c.handle && !(c.children && c.children.length)) return;
      topChips.appendChild(chip(c.title, c.count, { cat: i }));
    });
    if (!cats.length) topChips.innerHTML = '<p class="qb-list__msg">No categories configured yet — use the search above.</p>';

    function selectCat(i) {
      state.cat = i; state.sub = null;
      var c = cats[i];
      topChips.querySelectorAll('.qb-chip').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cat == i ? 'true' : 'false'); });
      subChips.innerHTML = '';
      if (c.children && c.children.length) {
        if (c.handle) subChips.appendChild(chip('All ' + c.title, c.count, { sub: -1 }));
        c.children.forEach(function (ch, j) { if (ch.handle) subChips.appendChild(chip(ch.title, ch.count, { sub: j })); });
        subChips.hidden = false;
        if (c.children.length === 1 && !c.handle) selectSub(0); else if (!c.handle) { listWrap.hidden = true; }
        else selectSub(-1);
      } else {
        subChips.hidden = true;
        loadCollection(c.handle, c.title);
      }
    }
    function selectSub(j) {
      state.sub = j;
      var c = cats[state.cat];
      subChips.querySelectorAll('.qb-chip').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.sub == j ? 'true' : 'false'); });
      if (j === -1) loadCollection(c.handle, c.title);
      else loadCollection(c.children[j].handle, c.title + ' › ' + c.children[j].title);
    }
    topChips.addEventListener('click', function (e) { var b = e.target.closest('[data-cat]'); if (b) selectCat(parseInt(b.dataset.cat, 10)); });
    subChips.addEventListener('click', function (e) { var b = e.target.closest('[data-sub]'); if (b) selectSub(parseInt(b.dataset.sub, 10)); });

    /* ---------- product list ---------- */
    function loadCollection(handle, title) {
      if (!handle) return;
      state.handle = handle; state.page = 1; state.pages = 1; state.products = [];
      rows.innerHTML = '<p class="qb-rows__msg">Loading…</p>';
      listWrap.hidden = false;
      listTitle.textContent = title;
      listCount.textContent = '';
      listFilter.value = '';
      listBrand.innerHTML = '<option value="">All brands</option>';
      loadMore.hidden = true;
      listMsg.textContent = '';
      fetchPage();
      if (window.innerWidth < 1024) listWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function fetchPage() {
      if (state.loading) return;
      state.loading = true;
      var handle = state.handle, page = state.page;
      loadMore.disabled = true;
      listMsg.textContent = page > 1 ? 'Loading more…' : '';
      fetch('/collections/' + encodeURIComponent(handle) + '?section_id=csl-qb-data&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          if (state.handle !== handle) return;
          var start = html.indexOf('{'), end = html.lastIndexOf('}');
          var data = JSON.parse(html.slice(start, end + 1));
          state.pages = data.pages || 1;
          state.products = state.products.concat(data.products || []);
          if (page === 1) rows.innerHTML = '';
          renderRows(data.products || []);
          listCount.textContent = state.products.length.toLocaleString() + ' of ' + (data.count || state.products.length).toLocaleString() + ' products loaded';
          loadMore.hidden = state.page >= state.pages;
          listMsg.textContent = state.page >= state.pages ? '' : 'Showing ' + state.products.length.toLocaleString() + ' — use the filter box or load more.';
          updateBrandFilter();
          applyListFilter();
        })
        .catch(function (err) {
          rows.innerHTML = '<p class="qb-rows__msg">Couldn’t load this category (' + esc(err.message) + '). Try the search above.</p>';
        })
        .then(function () { state.loading = false; loadMore.disabled = false; });
    }
    loadMore.addEventListener('click', function () { if (state.page < state.pages) { state.page++; fetchPage(); } });
    function productRow(p) {
      var el = rowTpl.content.firstElementChild.cloneNode(true);
      el.dataset.handle = p.h;
      el.dataset.search = (p.t + ' ' + (p.s || '') + ' ' + (p.v || '') + ' ' + (p.ty || '')).toLowerCase();
      el.dataset.vendor = p.v || '';
      var img = el.querySelector('.qb-row__img');
      if (p.i) img.src = p.i; else img.remove();
      var a = el.querySelector('.qb-row__title'); a.textContent = p.t; a.href = p.u || ('/products/' + p.h);
      el.querySelector('.qb-row__meta').textContent = [p.v, p.s ? 'SKU ' + p.s : '', p.ty].filter(Boolean).join(' · ');
      el.querySelector('.qb-row__price').textContent = p.pf || money(p.p);
      el._product = p;
      return el;
    }
    function renderRows(list) {
      var frag = document.createDocumentFragment();
      list.forEach(function (p) { frag.appendChild(productRow(p)); });
      rows.appendChild(frag);
      if (!rows.children.length) rows.innerHTML = '<p class="qb-rows__msg">No products in this category yet.</p>';
      markAdded();
    }
    function updateBrandFilter() {
      var current = listBrand.value;
      var brands = {};
      state.products.forEach(function (p) { if (p.v) brands[p.v] = (brands[p.v] || 0) + 1; });
      var names = Object.keys(brands).sort();
      listBrand.innerHTML = '<option value="">All brands (' + names.length + ')</option>' + names.map(function (n) { return '<option value="' + esc(n) + '">' + esc(n) + ' (' + brands[n] + ')</option>'; }).join('');
      listBrand.value = current;
    }
    function applyListFilter() {
      var q = listFilter.value.trim().toLowerCase(), brand = listBrand.value;
      var terms = q.split(/\s+/).filter(Boolean);
      var shown = 0;
      rows.querySelectorAll('[data-row]').forEach(function (r) {
        var ok = (!brand || r.dataset.vendor === brand) && terms.every(function (t) { return r.dataset.search.indexOf(t) !== -1; });
        r.hidden = !ok; if (ok) shown++;
      });
      var msg = rows.querySelector('[data-filter-msg]');
      if (!shown && rows.querySelector('[data-row]')) {
        if (!msg) { msg = document.createElement('p'); msg.className = 'qb-rows__msg'; msg.dataset.filterMsg = '1'; rows.appendChild(msg); }
        msg.textContent = 'No loaded products match. ' + (state.page < state.pages ? 'Load more, or ' : '') + 'try the catalog search above.';
      } else if (msg) msg.remove();
    }
    var ft;
    listFilter.addEventListener('input', function () { clearTimeout(ft); ft = setTimeout(applyListFilter, 120); });
    listBrand.addEventListener('change', applyListFilter);

    /* ---------- quantity + add (list rows & search rows) ---------- */
    root.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-qty-dec]'), inc = e.target.closest('[data-qty-inc]'), add = e.target.closest('[data-add]');
      if (dec || inc) {
        var input = (dec || inc).parentNode.querySelector('.qb-qty__input');
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, Math.min(9999, v + (inc ? 1 : -1)));
        return;
      }
      if (add) {
        var row = add.closest('[data-row]');
        var p = row && row._product;
        if (!p) return;
        var qty = parseInt(row.querySelector('.qb-qty__input').value, 10) || 1;
        addToList(p, qty);
        add.classList.add('is-added'); add.textContent = 'Added ✓';
        setTimeout(function () { add.classList.remove('is-added'); add.textContent = 'Add'; }, 1400);
      }
    });

    /* ---------- search ---------- */
    var st, lastResults = [];
    function closeResults() { results.hidden = true; results.innerHTML = ''; search.setAttribute('aria-expanded', 'false'); }
    function runSearch(q) {
      spinner.hidden = false;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.sku,variants.barcode,tag';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var prods = (json && json.resources && json.resources.results && json.resources.results.products) || [];
          results.innerHTML = '';
          if (!prods.length) { results.innerHTML = '<li class="qb-results__msg">No products match “' + esc(q) + '”.</li>'; }
          prods.forEach(function (p) {
            var v = (p.variants && p.variants[0]) || {};
            var cents = Math.round(parseFloat(v.price != null ? v.price : p.price) * 100) || 0;
            var item = { h: p.handle, t: p.title, v: p.vendor, ty: p.type, s: v.sku || '', p: cents, pf: money(cents), vid: v.id, i: p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''), u: p.url };
            var li = document.createElement('li');
            li.appendChild(productRow(item));
            results.appendChild(li);
          });
          results.hidden = false;
          search.setAttribute('aria-expanded', 'true');
          markAdded();
        })
        .catch(function () { results.innerHTML = '<li class="qb-results__msg">Search is unavailable right now.</li>'; results.hidden = false; })
        .then(function () { spinner.hidden = true; });
    }
    search.addEventListener('input', function () {
      clearTimeout(st);
      var q = search.value.trim();
      if (q.length < 2) { closeResults(); return; }
      st = setTimeout(function () { runSearch(q); }, 220);
    });
    search.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeResults(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-search-wrap]')) closeResults(); });

    /* ---------- the list ---------- */
    function addToList(p, qty) {
      var existing = state.list.filter(function (x) { return x.handle === p.h; })[0];
      if (existing) existing.qty = Math.min(9999, existing.qty + qty);
      else state.list.push({ handle: p.h, title: p.t, vendor: p.v || '', sku: p.s || '', type: p.ty || '', price: p.p || 0, image: p.i || '', url: p.u || ('/products/' + p.h), variant_id: p.vid, qty: qty });
      saveList();
      flash((existing ? 'Updated' : 'Added') + ': ' + p.t);
    }
    function saveList() { writeList(state.list); renderCart(); markAdded(); }
    function markAdded() {
      var handles = state.list.map(function (x) { return x.handle; });
      root.querySelectorAll('[data-row]').forEach(function (r) {
        var on = handles.indexOf(r.dataset.handle) !== -1;
        r.classList.toggle('is-in-list', on);
        var b = r.querySelector('[data-add]');
        if (b && !b.classList.contains('is-added')) b.textContent = on ? 'Add more' : 'Add';
      });
    }
    function totals() {
      var count = 0, sum = 0;
      state.list.forEach(function (x) { count += x.qty; sum += x.qty * (x.price || 0); });
      return { count: count, sum: sum };
    }
    function renderCart() {
      cartRows.innerHTML = '';
      var has = state.list.length > 0;
      cartEmpty.hidden = has; cartTotals.hidden = !has;
      [btnRequest, btnDownload, btnPrint, btnClear].forEach(function (b) { b.disabled = !has; });
      state.list.forEach(function (x) {
        var el = cartRowTpl.content.firstElementChild.cloneNode(true);
        el.dataset.handle = x.handle;
        var img = el.querySelector('.qb-crow__img'); if (x.image) img.src = x.image; else img.remove();
        var a = el.querySelector('.qb-crow__title'); a.textContent = x.title; a.href = x.url;
        el.querySelector('.qb-crow__meta').textContent = [x.vendor, x.sku ? 'SKU ' + x.sku : ''].filter(Boolean).join(' · ');
        el.querySelector('.qb-crow__unit').textContent = money(x.price) + ' each';
        el.querySelector('[data-cqty]').value = x.qty;
        el.querySelector('.qb-crow__total').textContent = money(x.price * x.qty);
        cartRows.appendChild(el);
      });
      var t = totals();
      cartTotal.textContent = money(t.sum);
      cartCount.textContent = t.count + (t.count === 1 ? ' item' : ' items') + (state.list.length !== t.count ? ' · ' + state.list.length + ' lines' : '');
    }
    cartRows.addEventListener('click', function (e) {
      var row = e.target.closest('[data-crow]'); if (!row) return;
      var item = state.list.filter(function (x) { return x.handle === row.dataset.handle; })[0]; if (!item) return;
      if (e.target.closest('[data-cremove]')) { state.list = state.list.filter(function (x) { return x !== item; }); saveList(); return; }
      if (e.target.closest('[data-cqty-inc]')) { item.qty = Math.min(9999, item.qty + 1); saveList(); }
      if (e.target.closest('[data-cqty-dec]')) { item.qty = Math.max(1, item.qty - 1); saveList(); }
    });
    cartRows.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cqty]'); if (!input) return;
      var row = input.closest('[data-crow]');
      var item = state.list.filter(function (x) { return x.handle === row.dataset.handle; })[0]; if (!item) return;
      item.qty = Math.max(1, Math.min(9999, parseInt(input.value, 10) || 1));
      saveList();
    });
    btnClear.addEventListener('click', function () { if (confirm('Clear your quote list?')) { state.list = []; saveList(); } });
    btnPrint.addEventListener('click', function () { window.print(); });
    btnDownload.addEventListener('click', function () {
      var lines = [['SKU', 'Product', 'Brand', 'Type', 'Qty', 'Unit list price', 'Line total', 'Link']];
      state.list.forEach(function (x) { lines.push([x.sku, x.title, x.vendor, x.type, x.qty, (x.price / 100).toFixed(2), (x.price * x.qty / 100).toFixed(2), location.origin + x.url]); });
      var t = totals();
      lines.push([], ['', 'Estimated list total', '', '', t.count, '', (t.sum / 100).toFixed(2), '']);
      var csv = lines.map(function (r) { return r.map(function (c) { return '"' + String(c == null ? '' : c).replace(/"/g, '""') + '"'; }).join(','); }).join('\r\n');
      var blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'csl-quote-list-' + new Date().toISOString().slice(0, 10) + '.csv';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    });

    /* ---------- request dialog ---------- */
    function bomText() {
      var t = totals();
      var out = ['QUOTE REQUEST — ' + (root.dataset.shopName || 'Creative Stage Lighting') + ' Quote Builder', 'Items: ' + state.list.length + ' lines, ' + t.count + ' units', ''];
      state.list.forEach(function (x, i) {
        out.push((i + 1) + '. ' + x.title + (x.vendor ? ' — ' + x.vendor : '') + (x.sku ? ' — SKU ' + x.sku : ''));
        out.push('   Qty ' + x.qty + ' × ' + money(x.price) + ' = ' + money(x.price * x.qty) + '   ' + location.origin + x.url);
      });
      out.push('', 'Estimated list total: ' + money(t.sum) + ' (list prices; quote may differ)');
      return out.join('\n');
    }
    function openRequest() {
      if (!dialog || !state.list.length) return;
      var t = totals();
      var body = $('[data-f-body]'), preview = $('[data-f-preview]'), summary = $('[data-f-summary]');
      var cnt = $('[data-f-count]'), tot = $('[data-f-total]');
      var bom = bomText();
      if (preview) preview.textContent = bom;
      if (summary) summary.textContent = '(' + state.list.length + ' lines, ' + t.count + ' units, ' + money(t.sum) + ' list)';
      if (cnt) cnt.value = state.list.length + ' lines / ' + t.count + ' units';
      if (tot) tot.value = money(t.sum);
      if (body) body.value = bom;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      var first = dialog.querySelector('input[name="contact[name]"]'); if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function closeRequest() { if (!dialog) return; if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open'); }
    btnRequest.addEventListener('click', openRequest);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-request-close]')) closeRequest(); });
    if (dialog) {
      dialog.addEventListener('click', function (e) { if (e.target === dialog) closeRequest(); });
      var form = dialog.querySelector('form');
      if (form) form.addEventListener('submit', function () {
        /* merge the customer's notes into the message body so everything is in one email */
        var body = $('[data-f-body]'), notes = $('[data-f-notes]');
        if (body) body.value = (notes && notes.value.trim() ? 'NOTES:\n' + notes.value.trim() + '\n\n' : '') + bomText();
      });
      var success = dialog.querySelector('[data-request-success]');
      var hasError = dialog.querySelector('.errors');
      if (success && /contact_posted=true/.test(location.search)) {
        if (postedBanner) postedBanner.hidden = false;
        setTimeout(function () { if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); }, 300);
        try { history.replaceState(null, '', location.pathname); } catch (e) { /* ignore */ }
      } else if (hasError) {
        setTimeout(openRequest, 300);
      }
    }
    var clearAfter = $('[data-clear-after]');
    if (clearAfter) clearAfter.addEventListener('click', function () { state.list = []; saveList(); postedBanner.hidden = true; });

    renderCart();
    /* deep link ?category=handle */
    try {
      var want = new URLSearchParams(location.search).get('category');
      if (want) cats.forEach(function (c, i) { if (c.handle === want) selectCat(i); (c.children || []).forEach(function (ch, j) { if (ch.handle === want) { selectCat(i); selectSub(j); } }); });
    } catch (e) { /* ignore */ }
  }

  function boot() { document.querySelectorAll('[data-qb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target && e.target.querySelector && e.target.querySelector('[data-qb]'); if (el) { delete el.dataset.qbReady; init(el); } });
})();
